

















import { POS_FILTER_KEYS } from 'gl-ms-positions';
import GenericFilter from '@/components/fleet/realtime/components/genericFilter.vue';
import { ACTION_GET_FILTER, ACTION_TOGGLE_FILTERS } from '../../../store/modules/realtime';

export default {
    data() {
        return {
            dispatcher: [],
            plateId: '',
            filterType: POS_FILTER_KEYS,
        };
    },
    computed: {
        dispatcherFilter(this: any) {
            return this.$store.getters.getFilter('dispatcher');
        },
        isMoreFilterOpen(this: any) {
            return this.$store.getters.isMoreFilterOpen;
        },
    },
    methods: {
        toggleMoreFilters(this: any) {
            this.$store.commit(ACTION_TOGGLE_FILTERS);
        },
        getFilter(this: any, key: string) {
            return this.$store.getters.getFilter(key);
        },
    },
    components: {
        GenericFilter,
    },
    mounted(this: any) {
        this.$store.dispatch(ACTION_GET_FILTER);
    },
};
